import { render, staticRenderFns } from "./menuInfo.vue?vue&type=template&id=4bb78370&"
import script from "./menuInfo.vue?vue&type=script&lang=js&"
export * from "./menuInfo.vue?vue&type=script&lang=js&"
import style0 from "./menuInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports